/* eslint-disable */
// AUTO-GENERATED by scripts/sync-selkirk-icons.mjs — do not edit manually.

import { ReactComponent as Svg_app_assay_compositing } from './svg/app-assay-compositing.svg';
import { ReactComponent as Svg_app_claim_management } from './svg/app-claim-management.svg';
import { ReactComponent as Svg_app_daily_report } from './svg/app-daily-report.svg';
import { ReactComponent as Svg_app_debug } from './svg/app-debug.svg';
import { ReactComponent as Svg_app_deviation_wizard } from './svg/app-deviation-wizard.svg';
import { ReactComponent as Svg_app_document_design } from './svg/app-document-design.svg';
import { ReactComponent as Svg_app_docusign } from './svg/app-docusign.svg';
import { ReactComponent as Svg_app_drilling_costs } from './svg/app-drilling-costs.svg';
import { ReactComponent as Svg_app_drilling_dashboard } from './svg/app-drilling-dashboard.svg';
import { ReactComponent as Svg_app_lab_approvals } from './svg/app-lab-approvals.svg';
import { ReactComponent as Svg_app_qaqc } from './svg/app-qaqc.svg';
import { ReactComponent as Svg_app_qgis_viewer } from './svg/app-qgis-viewer.svg';
import { ReactComponent as Svg_app_report_generator } from './svg/app-report-generator.svg';
import { ReactComponent as Svg_app_sample_tracking } from './svg/app-sample-tracking.svg';
import { ReactComponent as Svg_app_whos_in } from './svg/app-whos-in.svg';
import { ReactComponent as Svg_app_wolfwalker } from './svg/app-wolfwalker.svg';
import { ReactComponent as Svg_dd_asset_attachment_placeholder } from './svg/dd-asset-attachment-placeholder.svg';
import { ReactComponent as Svg_dd_close } from './svg/dd-close.svg';
import { ReactComponent as Svg_dd_folder } from './svg/dd-folder.svg';
import { ReactComponent as Svg_dd_qa_blocked } from './svg/dd-qa-blocked.svg';
import { ReactComponent as Svg_dd_tab_brand_library } from './svg/dd-tab-brand-library.svg';
import { ReactComponent as Svg_dd_tab_media_creator } from './svg/dd-tab-media-creator.svg';
import { ReactComponent as Svg_drill_filter_progress } from './svg/drill-filter-progress.svg';
import { ReactComponent as Svg_drill_filter_zone } from './svg/drill-filter-zone.svg';
import { ReactComponent as Svg_launcher_contact_it } from './svg/launcher-contact-it.svg';
import { ReactComponent as Svg_launcher_error } from './svg/launcher-error.svg';
import { ReactComponent as Svg_launcher_group_badge } from './svg/launcher-group-badge.svg';
import { ReactComponent as Svg_launcher_no_apps } from './svg/launcher-no-apps.svg';
import { ReactComponent as Svg_launcher_stat_security } from './svg/launcher-stat-security.svg';
import { ReactComponent as Svg_launcher_stat_uptime } from './svg/launcher-stat-uptime.svg';
import { ReactComponent as Svg_launcher_stat_version } from './svg/launcher-stat-version.svg';
import { ReactComponent as Svg_map_basemap_dark } from './svg/map-basemap-dark.svg';
import { ReactComponent as Svg_map_basemap_satellite } from './svg/map-basemap-satellite.svg';
import { ReactComponent as Svg_map_basemap_street } from './svg/map-basemap-street.svg';
import { ReactComponent as Svg_map_basemap_terrain } from './svg/map-basemap-terrain.svg';
import { ReactComponent as Svg_map_layer_add } from './svg/map-layer-add.svg';
import { ReactComponent as Svg_map_layer_hidden } from './svg/map-layer-hidden.svg';
import { ReactComponent as Svg_map_layer_visible } from './svg/map-layer-visible.svg';
import { ReactComponent as Svg_map_zoom_to_feature } from './svg/map-zoom-to-feature.svg';
import { ReactComponent as Svg_nav_chevron_down } from './svg/nav-chevron-down.svg';
import { ReactComponent as Svg_nav_help } from './svg/nav-help.svg';
import { ReactComponent as Svg_nav_home } from './svg/nav-home.svg';
import { ReactComponent as Svg_nav_notifications } from './svg/nav-notifications.svg';
import { ReactComponent as Svg_nav_profile } from './svg/nav-profile.svg';
import { ReactComponent as Svg_nav_settings } from './svg/nav-settings.svg';
import { ReactComponent as Svg_nav_sign_out } from './svg/nav-sign-out.svg';
import { ReactComponent as Svg_nav_theme } from './svg/nav-theme.svg';
import { ReactComponent as Svg_qaqc_domain_blank } from './svg/qaqc-domain-blank.svg';
import { ReactComponent as Svg_qaqc_domain_duplicate } from './svg/qaqc-domain-duplicate.svg';
import { ReactComponent as Svg_sample_loc_air } from './svg/sample-loc-air.svg';
import { ReactComponent as Svg_sample_loc_office } from './svg/sample-loc-office.svg';
import { ReactComponent as Svg_sample_loc_truck } from './svg/sample-loc-truck.svg';
import { ReactComponent as Svg_ui_api_link } from './svg/ui-api-link.svg';
import { ReactComponent as Svg_ui_calculator } from './svg/ui-calculator.svg';
import { ReactComponent as Svg_ui_camera_map } from './svg/ui-camera-map.svg';
import { ReactComponent as Svg_ui_clock_eta } from './svg/ui-clock-eta.svg';
import { ReactComponent as Svg_ui_database } from './svg/ui-database.svg';
import { ReactComponent as Svg_ui_depth } from './svg/ui-depth.svg';
import { ReactComponent as Svg_ui_dispatch } from './svg/ui-dispatch.svg';
import { ReactComponent as Svg_ui_edit } from './svg/ui-edit.svg';
import { ReactComponent as Svg_ui_empty_mailbox } from './svg/ui-empty-mailbox.svg';
import { ReactComponent as Svg_ui_error } from './svg/ui-error.svg';
import { ReactComponent as Svg_ui_export } from './svg/ui-export.svg';
import { ReactComponent as Svg_ui_filter } from './svg/ui-filter.svg';
import { ReactComponent as Svg_ui_hourglass } from './svg/ui-hourglass.svg';
import { ReactComponent as Svg_ui_news } from './svg/ui-news.svg';
import { ReactComponent as Svg_ui_numbers } from './svg/ui-numbers.svg';
import { ReactComponent as Svg_ui_pause } from './svg/ui-pause.svg';
import { ReactComponent as Svg_ui_pointer_hint } from './svg/ui-pointer-hint.svg';
import { ReactComponent as Svg_ui_remove } from './svg/ui-remove.svg';
import { ReactComponent as Svg_ui_search } from './svg/ui-search.svg';
import { ReactComponent as Svg_ui_sequential_leach } from './svg/ui-sequential-leach.svg';
import { ReactComponent as Svg_ui_shift } from './svg/ui-shift.svg';
import { ReactComponent as Svg_ui_sort_asc } from './svg/ui-sort-asc.svg';
import { ReactComponent as Svg_ui_sort_neutral } from './svg/ui-sort-neutral.svg';
import { ReactComponent as Svg_ui_star } from './svg/ui-star.svg';
import { ReactComponent as Svg_ui_theme_light } from './svg/ui-theme-light.svg';
import { ReactComponent as Svg_ui_tip } from './svg/ui-tip.svg';
import { ReactComponent as Svg_ui_tools } from './svg/ui-tools.svg';
import { ReactComponent as Svg_ui_trophy } from './svg/ui-trophy.svg';
import { ReactComponent as Svg_ui_wave_hello } from './svg/ui-wave-hello.svg';
import { ReactComponent as Svg_whosin_tab_onsite } from './svg/whosin-tab-onsite.svg';

export const ASSET_ID_TO_COMPONENT = {
  'nav-home': Svg_nav_home,
  'nav-help': Svg_nav_help,
  'nav-settings': Svg_nav_settings,
  'nav-notifications': Svg_nav_notifications,
  'nav-profile': Svg_nav_profile,
  'nav-theme': Svg_nav_theme,
  'nav-sign-out': Svg_nav_sign_out,
  'nav-chevron-down': Svg_nav_chevron_down,
  'app-wolfwalker': Svg_app_wolfwalker,
  'app-drilling-dashboard': Svg_app_drilling_dashboard,
  'app-claim-management': Svg_app_claim_management,
  'app-sample-tracking': Svg_app_sample_tracking,
  'app-assay-compositing': Svg_app_assay_compositing,
  'app-qaqc': Svg_app_qaqc,
  'app-drilling-costs': Svg_app_drilling_costs,
  'app-deviation-wizard': Svg_app_deviation_wizard,
  'app-drillhole-validation': Svg_app_qaqc,
  'app-lab-approvals': Svg_app_lab_approvals,
  'app-docusign': Svg_app_docusign,
  'app-debug': Svg_app_debug,
  'app-whos-in': Svg_app_whos_in,
  'app-daily-report': Svg_app_daily_report,
  'app-document-design': Svg_app_document_design,
  'app-report-generator': Svg_app_report_generator,
  'app-qgis-viewer': Svg_app_qgis_viewer,
  'app-administration': Svg_nav_settings,
  'launcher-group-badge': Svg_launcher_group_badge,
  'launcher-stat-apps': Svg_app_report_generator,
  'launcher-stat-security': Svg_launcher_stat_security,
  'launcher-stat-uptime': Svg_launcher_stat_uptime,
  'launcher-stat-version': Svg_launcher_stat_version,
  'launcher-no-apps': Svg_launcher_no_apps,
  'launcher-contact-it': Svg_launcher_contact_it,
  'launcher-error': Svg_launcher_error,
  'dd-tab-documents': Svg_app_daily_report,
  'dd-tab-brand-library': Svg_dd_tab_brand_library,
  'dd-tab-media-creator': Svg_dd_tab_media_creator,
  'dd-folder': Svg_dd_folder,
  'dd-tree-branch': Svg_nav_chevron_down,
  'dd-close': Svg_dd_close,
  'dd-approved-external': Svg_app_qaqc,
  'dd-asset-chart-placeholder': Svg_app_report_generator,
  'dd-asset-attachment-placeholder': Svg_dd_asset_attachment_placeholder,
  'dd-qa-blocked': Svg_dd_qa_blocked,
  'dd-no-issues': Svg_app_qaqc,
  'whosin-tab-onsite': Svg_whosin_tab_onsite,
  'whosin-tab-breakdown': Svg_app_deviation_wizard,
  'whosin-tab-full-roster': Svg_app_lab_approvals,
  'drill-filter-status': Svg_app_deviation_wizard,
  'drill-filter-zone': Svg_drill_filter_zone,
  'drill-filter-rig': Svg_nav_settings,
  'drill-filter-progress': Svg_drill_filter_progress,
  'sample-loc-drill': Svg_app_drilling_dashboard,
  'sample-loc-truck': Svg_sample_loc_truck,
  'sample-loc-lab': Svg_app_sample_tracking,
  'sample-loc-air': Svg_sample_loc_air,
  'sample-loc-office': Svg_sample_loc_office,
  'sample-loc-complete': Svg_app_qaqc,
  'qaqc-domain-control-standard': Svg_app_deviation_wizard,
  'qaqc-domain-blank': Svg_qaqc_domain_blank,
  'qaqc-domain-duplicate': Svg_qaqc_domain_duplicate,
  'qaqc-domain-fallback': Svg_app_report_generator,
  'map-basemap-street': Svg_map_basemap_street,
  'map-basemap-satellite': Svg_map_basemap_satellite,
  'map-basemap-terrain': Svg_map_basemap_terrain,
  'map-basemap-dark': Svg_map_basemap_dark,
  'map-zoom-to-feature': Svg_map_zoom_to_feature,
  'map-layer-visible': Svg_map_layer_visible,
  'map-layer-hidden': Svg_map_layer_hidden,
  'map-layer-remove': Svg_dd_close,
  'map-layer-add': Svg_map_layer_add,
  'ui-close': Svg_dd_close,
  'ui-search': Svg_ui_search,
  'ui-refresh': Svg_qaqc_domain_duplicate,
  'ui-export': Svg_ui_export,
  'ui-add': Svg_map_layer_add,
  'ui-remove': Svg_ui_remove,
  'ui-edit': Svg_ui_edit,
  'ui-chart-analytics': Svg_app_report_generator,
  'ui-document': Svg_app_daily_report,
  'ui-clipboard-list': Svg_app_lab_approvals,
  'ui-calendar-date': Svg_app_whos_in,
  'ui-location-pin': Svg_map_zoom_to_feature,
  'ui-globe-location': Svg_app_qgis_viewer,
  'ui-depth': Svg_ui_depth,
  'ui-dispatch': Svg_ui_dispatch,
  'ui-camera-map': Svg_ui_camera_map,
  'ui-database': Svg_ui_database,
  'ui-folder-open': Svg_dd_folder,
  'ui-filter': Svg_ui_filter,
  'ui-tip': Svg_ui_tip,
  'ui-warning': Svg_launcher_error,
  'ui-error': Svg_ui_error,
  'ui-success': Svg_app_qaqc,
  'ui-access-denied': Svg_dd_qa_blocked,
  'ui-pause': Svg_ui_pause,
  'ui-hourglass': Svg_ui_hourglass,
  'ui-trophy': Svg_ui_trophy,
  'ui-investigation': Svg_ui_search,
  'ui-numbers': Svg_ui_numbers,
  'ui-security-lock': Svg_launcher_stat_security,
  'ui-pointer-hint': Svg_ui_pointer_hint,
  'ui-sort-neutral': Svg_ui_sort_neutral,
  'ui-sort-asc': Svg_ui_sort_asc,
  'ui-sort-desc': Svg_nav_chevron_down,
  'ui-check-on': Svg_app_qaqc,
  'ui-check-off': Svg_dd_close,
  'ui-radio-off': Svg_qaqc_domain_blank,
  'ui-star': Svg_ui_star,
  'ui-theme-light': Svg_ui_theme_light,
  'ui-theme-dark': Svg_map_basemap_dark,
  'ui-shift': Svg_ui_shift,
  'ui-news': Svg_ui_news,
  'ui-clock-eta': Svg_ui_clock_eta,
  'ui-empty-mailbox': Svg_ui_empty_mailbox,
  'ui-sequential-leach': Svg_ui_sequential_leach,
  'ui-calculator': Svg_ui_calculator,
  'ui-api-link': Svg_ui_api_link,
  'ui-tools': Svg_ui_tools,
  'ui-wave-hello': Svg_ui_wave_hello,
};

export const ASSET_ID_TO_PUBLIC_PATH = {
  'nav-home': '/selkirk-icons/nav-home.svg',
  'nav-help': '/selkirk-icons/nav-help.svg',
  'nav-settings': '/selkirk-icons/nav-settings.svg',
  'nav-notifications': '/selkirk-icons/nav-notifications.svg',
  'nav-profile': '/selkirk-icons/nav-profile.svg',
  'nav-theme': '/selkirk-icons/nav-theme.svg',
  'nav-sign-out': '/selkirk-icons/nav-sign-out.svg',
  'nav-chevron-down': '/selkirk-icons/nav-chevron-down.svg',
  'app-wolfwalker': '/selkirk-icons/app-wolfwalker.svg',
  'app-drilling-dashboard': '/selkirk-icons/app-drilling-dashboard.svg',
  'app-claim-management': '/selkirk-icons/app-claim-management.svg',
  'app-sample-tracking': '/selkirk-icons/app-sample-tracking.svg',
  'app-assay-compositing': '/selkirk-icons/app-assay-compositing.svg',
  'app-qaqc': '/selkirk-icons/app-qaqc.svg',
  'app-drilling-costs': '/selkirk-icons/app-drilling-costs.svg',
  'app-deviation-wizard': '/selkirk-icons/app-deviation-wizard.svg',
  'app-drillhole-validation': '/selkirk-icons/app-qaqc.svg',
  'app-lab-approvals': '/selkirk-icons/app-lab-approvals.svg',
  'app-docusign': '/selkirk-icons/app-docusign.svg',
  'app-debug': '/selkirk-icons/app-debug.svg',
  'app-whos-in': '/selkirk-icons/app-whos-in.svg',
  'app-daily-report': '/selkirk-icons/app-daily-report.svg',
  'app-document-design': '/selkirk-icons/app-document-design.svg',
  'app-report-generator': '/selkirk-icons/app-report-generator.svg',
  'app-qgis-viewer': '/selkirk-icons/app-qgis-viewer.svg',
  'app-administration': '/selkirk-icons/nav-settings.svg',
  'launcher-group-badge': '/selkirk-icons/launcher-group-badge.svg',
  'launcher-stat-apps': '/selkirk-icons/app-report-generator.svg',
  'launcher-stat-security': '/selkirk-icons/launcher-stat-security.svg',
  'launcher-stat-uptime': '/selkirk-icons/launcher-stat-uptime.svg',
  'launcher-stat-version': '/selkirk-icons/launcher-stat-version.svg',
  'launcher-no-apps': '/selkirk-icons/launcher-no-apps.svg',
  'launcher-contact-it': '/selkirk-icons/launcher-contact-it.svg',
  'launcher-error': '/selkirk-icons/launcher-error.svg',
  'dd-tab-documents': '/selkirk-icons/app-daily-report.svg',
  'dd-tab-brand-library': '/selkirk-icons/dd-tab-brand-library.svg',
  'dd-tab-media-creator': '/selkirk-icons/dd-tab-media-creator.svg',
  'dd-folder': '/selkirk-icons/dd-folder.svg',
  'dd-tree-branch': '/selkirk-icons/nav-chevron-down.svg',
  'dd-close': '/selkirk-icons/dd-close.svg',
  'dd-approved-external': '/selkirk-icons/app-qaqc.svg',
  'dd-asset-chart-placeholder': '/selkirk-icons/app-report-generator.svg',
  'dd-asset-attachment-placeholder': '/selkirk-icons/dd-asset-attachment-placeholder.svg',
  'dd-qa-blocked': '/selkirk-icons/dd-qa-blocked.svg',
  'dd-no-issues': '/selkirk-icons/app-qaqc.svg',
  'whosin-tab-onsite': '/selkirk-icons/whosin-tab-onsite.svg',
  'whosin-tab-breakdown': '/selkirk-icons/app-deviation-wizard.svg',
  'whosin-tab-full-roster': '/selkirk-icons/app-lab-approvals.svg',
  'drill-filter-status': '/selkirk-icons/app-deviation-wizard.svg',
  'drill-filter-zone': '/selkirk-icons/drill-filter-zone.svg',
  'drill-filter-rig': '/selkirk-icons/nav-settings.svg',
  'drill-filter-progress': '/selkirk-icons/drill-filter-progress.svg',
  'sample-loc-drill': '/selkirk-icons/app-drilling-dashboard.svg',
  'sample-loc-truck': '/selkirk-icons/sample-loc-truck.svg',
  'sample-loc-lab': '/selkirk-icons/app-sample-tracking.svg',
  'sample-loc-air': '/selkirk-icons/sample-loc-air.svg',
  'sample-loc-office': '/selkirk-icons/sample-loc-office.svg',
  'sample-loc-complete': '/selkirk-icons/app-qaqc.svg',
  'qaqc-domain-control-standard': '/selkirk-icons/app-deviation-wizard.svg',
  'qaqc-domain-blank': '/selkirk-icons/qaqc-domain-blank.svg',
  'qaqc-domain-duplicate': '/selkirk-icons/qaqc-domain-duplicate.svg',
  'qaqc-domain-fallback': '/selkirk-icons/app-report-generator.svg',
  'map-basemap-street': '/selkirk-icons/map-basemap-street.svg',
  'map-basemap-satellite': '/selkirk-icons/map-basemap-satellite.svg',
  'map-basemap-terrain': '/selkirk-icons/map-basemap-terrain.svg',
  'map-basemap-dark': '/selkirk-icons/map-basemap-dark.svg',
  'map-zoom-to-feature': '/selkirk-icons/map-zoom-to-feature.svg',
  'map-layer-visible': '/selkirk-icons/map-layer-visible.svg',
  'map-layer-hidden': '/selkirk-icons/map-layer-hidden.svg',
  'map-layer-remove': '/selkirk-icons/dd-close.svg',
  'map-layer-add': '/selkirk-icons/map-layer-add.svg',
  'ui-close': '/selkirk-icons/dd-close.svg',
  'ui-search': '/selkirk-icons/ui-search.svg',
  'ui-refresh': '/selkirk-icons/qaqc-domain-duplicate.svg',
  'ui-export': '/selkirk-icons/ui-export.svg',
  'ui-add': '/selkirk-icons/map-layer-add.svg',
  'ui-remove': '/selkirk-icons/ui-remove.svg',
  'ui-edit': '/selkirk-icons/ui-edit.svg',
  'ui-chart-analytics': '/selkirk-icons/app-report-generator.svg',
  'ui-document': '/selkirk-icons/app-daily-report.svg',
  'ui-clipboard-list': '/selkirk-icons/app-lab-approvals.svg',
  'ui-calendar-date': '/selkirk-icons/app-whos-in.svg',
  'ui-location-pin': '/selkirk-icons/map-zoom-to-feature.svg',
  'ui-globe-location': '/selkirk-icons/app-qgis-viewer.svg',
  'ui-depth': '/selkirk-icons/ui-depth.svg',
  'ui-dispatch': '/selkirk-icons/ui-dispatch.svg',
  'ui-camera-map': '/selkirk-icons/ui-camera-map.svg',
  'ui-database': '/selkirk-icons/ui-database.svg',
  'ui-folder-open': '/selkirk-icons/dd-folder.svg',
  'ui-filter': '/selkirk-icons/ui-filter.svg',
  'ui-tip': '/selkirk-icons/ui-tip.svg',
  'ui-warning': '/selkirk-icons/launcher-error.svg',
  'ui-error': '/selkirk-icons/ui-error.svg',
  'ui-success': '/selkirk-icons/app-qaqc.svg',
  'ui-access-denied': '/selkirk-icons/dd-qa-blocked.svg',
  'ui-pause': '/selkirk-icons/ui-pause.svg',
  'ui-hourglass': '/selkirk-icons/ui-hourglass.svg',
  'ui-trophy': '/selkirk-icons/ui-trophy.svg',
  'ui-investigation': '/selkirk-icons/ui-search.svg',
  'ui-numbers': '/selkirk-icons/ui-numbers.svg',
  'ui-security-lock': '/selkirk-icons/launcher-stat-security.svg',
  'ui-pointer-hint': '/selkirk-icons/ui-pointer-hint.svg',
  'ui-sort-neutral': '/selkirk-icons/ui-sort-neutral.svg',
  'ui-sort-asc': '/selkirk-icons/ui-sort-asc.svg',
  'ui-sort-desc': '/selkirk-icons/nav-chevron-down.svg',
  'ui-check-on': '/selkirk-icons/app-qaqc.svg',
  'ui-check-off': '/selkirk-icons/dd-close.svg',
  'ui-radio-off': '/selkirk-icons/qaqc-domain-blank.svg',
  'ui-star': '/selkirk-icons/ui-star.svg',
  'ui-theme-light': '/selkirk-icons/ui-theme-light.svg',
  'ui-theme-dark': '/selkirk-icons/map-basemap-dark.svg',
  'ui-shift': '/selkirk-icons/ui-shift.svg',
  'ui-news': '/selkirk-icons/ui-news.svg',
  'ui-clock-eta': '/selkirk-icons/ui-clock-eta.svg',
  'ui-empty-mailbox': '/selkirk-icons/ui-empty-mailbox.svg',
  'ui-sequential-leach': '/selkirk-icons/ui-sequential-leach.svg',
  'ui-calculator': '/selkirk-icons/ui-calculator.svg',
  'ui-api-link': '/selkirk-icons/ui-api-link.svg',
  'ui-tools': '/selkirk-icons/ui-tools.svg',
  'ui-wave-hello': '/selkirk-icons/ui-wave-hello.svg',
};

export const SELKIRK_ICON_ASSET_IDS = Object.keys(ASSET_ID_TO_COMPONENT);
